<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div>
      <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item label="请选择日期" prop="localDate">
                  <a-date-picker style="width: 100%" v-model="queryParam.localDate" format="YYYY-MM-DD"  valueFormat="YYYY-MM-DD" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('订单类型')" prop="orderType">
                  <a-select :placeholder="$t('请选择')+$t('订单类型')" style="width: 100%" v-model="queryParam.orderType" allowClear>
                    <a-select-option v-for="(item, index) in this.customDict.OrderTypeEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="!advanced && 6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </div>
      <!-- 操作 -->
        <div class="table-operations">
          <table-setting
            :style="{float: 'right'}"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList" />
        </div>
        <!-- 数据展示 -->
        <a-table
          class="sta-head-footer-table"
          :loading="loading"
          size="small"
          rowKey="time"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          @change="handleSortChange"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :bordered="tableBordered"
        >
          <span slot="operation" slot-scope="text, record">
            <a-divider type="vertical" />
            <a @click="jumpOrder(record)" >
               <a-icon type="eye" />{{$t('查看订单')}}
            </a>
              <a-divider type="vertical" />
            <a @click="handleRefund(record)" v-hasPermi="['order:payment:refund']">
            <a-icon type="edit" />{{$t('免单')}}
          </a>
          </span>

<!--          <span slot="status" slot-scope="text, record">
            <a-select style="width: 50%" v-model="record.status"  @change="onStatusChange(record)">
              <a-select-option v-for="(item, index) in customDict.GoodsOnOffEnum" :value="item.type"
                               :key="index">
                        {{ item.name }}
              </a-select-option>
            </a-select>
          </span>-->
        </a-table>
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import {tableMixin} from '@/store/table-mixin'
import moment from 'moment';
import {orderDayAmount} from "@/api/statistics/order";
import {freeApply, refundAmount} from "@/api/order/refund";


export default {
  name: 'OrderTime',
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      categoryList: [{id: "0", categoryName: ''}],
      cateOptions: [],
      brandList: [],
      labelList: [],
      starList: [],
      clubList: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        localDate: undefined,
        startTime: undefined,
        endTime: undefined,
        time : undefined,
        orderType: undefined,
        sortField: 'goodsId',
        sortOrder: 'desc',
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('时段'),
          dataIndex: 'time',
          scopedSlots: {customRender: 'time'},
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: '订单量',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'totalOrderCount',
        },

        {
          title: '订单金额',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'totalOrderAmount',
        },
        {
          title: '商城订单量',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'mallOrderCount',
        },
        {
          title: '商城订单金额',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'mallOrderAmount',
        },
        {
          title: '门票订单量',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'ticketOrderCount',
        },
        {
          title: '门票订单金额',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'ticketOrderAmount',
        },
        {
          title: '线下订单量',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'cityOrderCount',
        },
        {
          title: '线下订单金额',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'cityOrderAmount',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    };
  },
  filters: {
  },
  created () {
    this.defaultDate()
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商品列表 */
    getList () {
      this.loading = true
      orderDayAmount(this.queryParam).then(response => {
        this.list = response.data
        this.loading = false
      })
    },
    defaultDate() {
      const lastMonthToday = moment().subtract(8, 'day'); //
      this.queryParam.localDate =  lastMonthToday.format('YYYY-MM-DD') ;
      console.log(this.queryParam.localDate)
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        localDate: undefined,
        startTime: undefined,
        endTime: undefined,
        time : undefined,
        orderType: undefined,
        sortField: 'goodsId',
        sortOrder: 'desc',
        pageNum: 1,
        pageSize: 10
      }
      this.defaultDate()
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.goodsId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    jumpOrder(record) {
      let createBeginTime =  this.queryParam.localDate +" "+ record.time +":00:00"
      let createEndTime =  this.queryParam.localDate +" "+ record.time +":59:59"
      this.$router.push({
        name: 'Sell',
        params:
          {
            createBeginTime: createBeginTime,
            createEndTime: createEndTime,
          }
      })
    },
    handleJumpStar(starId) {
      this.$router.push({
        name: 'Star',
        params:
          {
            id: starId
          }
      })
    },

    handleRefund(record) {
      let that = this
      let data =  this.queryParam
      this.queryParam.time = record.time
      this.$confirm({
        title: '是否确认退款',
        content: '此操作将全部退款',
        onOk () {
          freeApply(data).then(resp => {
            if (resp.code==="20001") {
              that.$message.success('退款成功', 3);
              that.open = false
              that.getList()
            }
          });
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/statistics/goods/goods/export', {
            ...that.queryParam
          }, `商品报表_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出选中数据'),
        onOk () {
          that.download('biz/admin/statistics/goods/goods/export', queryParam, `商品报表_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        }
      })
    }
  }
}
</script>
<style>
</style>
